import { render, staticRenderFns } from "./VasionTermsOfServiceModal.vue?vue&type=template&id=6e28841f&scoped=true"
import script from "./VasionTermsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./VasionTermsOfServiceModal.vue?vue&type=script&lang=js"
import style0 from "./VasionTermsOfServiceModal.vue?vue&type=style&index=0&id=6e28841f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28841f",
  null
  
)

export default component.exports